import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutRow, FlexLayoutCol } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { InfoCard } from '../../../../vtex-apps/store-components/InfoCard/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

export default function BannerSectionGroup() {
	return {
		componentName: 'VisibilityLayout',
		componentId: uuidv4(),
		variables,
		componentGroup: 'BannerSectionGroup',
		props: VisibilityLayout({ mzTitle: 'MZ | Mosaico - Banners (On/Off)' }).props,
		childrenComponents: [
			FlexLayoutRow(
				{
					colSizing: 'auto',
					colGap: 2,
					blockClass: 'flex-row__banner-section-2',
					mzTitle: 'MZ | Mosaico - Banners',
				},
				[
					FlexLayoutCol(
						{
							width: { desktop: '40%', tablet: '100%', phone: '100%' },
							blockClass: 'flex-col-left__banner-section-2',
						},
						[InfoCard(infoCardLeft)],
					),
					FlexLayoutCol(
						{
							width: { desktop: '60%', tablet: '100%', phone: '100%' },
							blockClass: 'flex-col-right__banner-section-2',
						},
						infoCardRight.map((infoCardProps) => InfoCard(infoCardProps)),
					),
				],
			),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--brand-color-primary-pure', to: '--banner-section-2-card-bg-color', name: 'Card Bg Color' },
			{ from: '--white', to: '--banner-section-2-text-color', name: 'Text Color' },
			{ from: '--white', to: '--banner-section-2-cta-text-color', name: 'CTA Text Color' },
			{ from: '--cta-color-pure', to: '--banner-section-2-cta-color', name: 'CTA Color' },
			{ from: '--cta-color-hover', to: '--banner-section-2-cta-color-hover', name: 'CTA Color Hover' },
			{ from: '--cta-color-focus', to: '--banner-section-2-cta-color-focus', name: 'CTA Color Active' },
			{ from: '--transparent', to: '--bsg-2-bg-color', name: 'Background' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: 0, to: '--banner-section-2-card-out-radius', name: 'Card Border Radius' },
			{ from: '--border-radius-md', to: '--banner-section-2-card-radius', name: 'Card Box Border Radius' },
			{ from: '--border-radius-sm', to: '--banner-section-2-cta-radius', name: 'CTA Border Radius' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xl', to: '--banner-section-2-heading-fontsize', name: 'Heading Fontsize' },
			{ from: '--font-size-xl', to: '--banner-section-2-heading-fontsize-m', name: 'Heading Fontsize Mobile' },
			{ from: '--font-size-md', to: '--banner-section-2-subheading-fontsize', name: 'Subheading Fontsize' },
			{
				from: '--font-size-md',
				to: '--banner-section-2-subheading-fontsize-m',
				name: 'Subheading Fontsize Mobile',
			},
			{ from: '--font-size-sm', to: '--banner-section-2-cta-fontsize', name: 'CTA Fontsize' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--banner-section-2-fontfamily', name: 'Font Family' },
			{ from: '--main-font', to: '--banner-section-2-cta-fontfamily', name: 'CTA Font Family' },
		],
	},
];

const infoCardLeft = {
	id: 'info-card-banner-1',
	isFullModeStyle: true,
	callToActionText: 'Ver todos os produtos',
	callToActionUrl: '/',
	callToActionMode: 'button',
	blockClass: 'info-card-left-img__banner-section-2',
	textAlignment: 'center',
	imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683045279552-brand-group-img-10.png',
};
const infoCardRight = [
	{
		id: 'info-card-banner-2',
		isFullModeStyle: true,
		imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683045263912-brand-group-img-9.png',
		callToActionText: 'Ver produtos',
		callToActionUrl: '/',
		callToActionMode: 'button',
		blockClass: 'info-card-img__banner-section-2',
		textAlignment: 'center',
	},
	{
		id: 'info-card-banner-3',
		isFullModeStyle: true,
		imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683045263912-brand-group-img-9.png',
		callToActionText: 'Ver produtos',
		callToActionUrl: '/',
		callToActionMode: 'button',
		blockClass: 'info-card-img__banner-section-2',
		textAlignment: 'center',
	},
	{
		id: 'info-card-banner-4',
		isFullModeStyle: true,
		imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683045263912-brand-group-img-9.png',
		callToActionText: 'Ver produtos',
		callToActionUrl: '/',
		callToActionMode: 'button',
		blockClass: 'info-card-img__banner-section-2',
		textAlignment: 'center',
	},
	{
		id: 'info-card-banner-5',
		isFullModeStyle: true,
		imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683045263912-brand-group-img-9.png',
		callToActionText: 'Ver produtos',
		callToActionUrl: '/',
		callToActionMode: 'button',
		blockClass: 'info-card-img__banner-section-2',
		textAlignment: 'center',
	},
	{
		id: 'info-card-banner-6',
		isFullModeStyle: true,
		imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683045263912-brand-group-img-9.png',
		callToActionText: 'Ver produtos',
		callToActionUrl: '/',
		callToActionMode: 'button',
		blockClass: 'info-card-img__banner-section-2',
		textAlignment: 'center',
	},
	{
		id: 'info-card-banner-7',
		isFullModeStyle: true,
		imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683045263912-brand-group-img-9.png',
		callToActionText: 'Ver produtos',
		callToActionUrl: '/',
		callToActionMode: 'button',
		blockClass: 'info-card-img__banner-section-2',
		textAlignment: 'center',
	},
];
